import React from 'react';
import { Mail, TrendingUp, Users } from 'lucide-react';

const AdPlaceholder = ({ width = 1200, height = 300, variant = 'hero' }) => {
  const getContent = () => {
    switch (variant) {
      case 'hero':
        return {
          title: 'YOUR AD HERE',
          subtitle: 'Reach thousands of sports medicine professionals',
          icon: <TrendingUp size={48} />
        };
      case 'sidebar':
        return {
          title: 'ADVERTISE HERE',
          subtitle: 'Premium sidebar placement',
          icon: <Users size={40} />
        };
      case 'inline':
        return {
          title: 'YOUR AD',
          subtitle: 'High-visibility placement',
          icon: <TrendingUp size={36} />
        };
      default:
        return {
          title: 'AD SPACE AVAILABLE',
          subtitle: 'Contact us for rates',
          icon: <Mail size={40} />
        };
    }
  };

  const content = getContent();

  return (
    <div
      className="ad-placeholder relative overflow-hidden cursor-pointer transition-all hover:shadow-xl"
      style={{
        width: width === 'auto' ? '100%' : `${width}px`,
        height: `${height}px`,
        maxWidth: '100%',
        background: 'linear-gradient(135deg, #2c3e7d 0%, #4a5f9d 50%, #6b7ba8 100%)',
      }}
      onClick={() => window.location.href = 'mailto:admin@chirosport.co.za?subject=Advertising Inquiry'}
    >
      {/* Animated background pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full"
          style={{
            backgroundImage: `repeating-linear-gradient(
              45deg,
              transparent,
              transparent 10px,
              rgba(255,255,255,.05) 10px,
              rgba(255,255,255,.05) 20px
            )`
          }}
        />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-white p-6">
        <div className="mb-3 animate-pulse">
          {content.icon}
        </div>
        
        <h3 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-2 tracking-wide text-center">
          {content.title}
        </h3>
        
        <p className="text-sm md:text-base lg:text-lg text-gray-200 mb-4 text-center max-w-md">
          {content.subtitle}
        </p>
        
        <div className="flex items-center gap-2 text-sm text-gray-300 hover:text-white transition-colors">
          <Mail size={16} />
          <span>admin@chirosport.co.za</span>
        </div>

        {/* Call to action badge */}
        <div className="mt-4 px-4 py-2 bg-white/20 backdrop-blur-sm rounded-full text-xs font-semibold">
          Click to inquire
        </div>
      </div>

      {/* Corner badge */}
      <div className="absolute top-2 right-2 bg-yellow-400 text-gray-900 px-3 py-1 rounded-full text-xs font-bold">
        AVAILABLE
      </div>
    </div>
  );
};

export default AdPlaceholder;
